import request from "@/utils/followUp/request";

const BASE_URL = "/internal/hospDept";
// 科室管理-分页列表
export function deptPageList(query) {
  return request({
    url: `${BASE_URL}/list`,
    method: "get",
    params: query,
  });
}

// 科室管理-科室子科室
export function deptChildren(id) {
  return request({
    url: `${BASE_URL}/children/${id}`,
    method: "get",
  });
}

// 科室管理-新增科室
export function addDept(data) {
  return request({
    url: `${BASE_URL}/save`,
    method: "post",
    data,
  });
}

// 科室管理-新增科室
export function updateDept(data) {
  return request({
    url: `${BASE_URL}/save`,
    method: "patch",
    data,
  });
}

// 科室管理- 删除科室
export function deleteDept(id) {
  return request({
    url: `${BASE_URL}/del/${id}`,
    method: "post",
  });
}

// 科室管理-所有一级科室
export function getAllFirstDept(query) {
  return request({
    url: `${BASE_URL}/all`,
    method: "get",
    params: query,
  });
}
